module.exports = __webpack_public_path__ + "img/icon-plane.90002e6e.svg";